import { useMemo } from 'react';

// Chave para salvar o valor no sessionStorage e evitar conflitos
const CLEAR_STORAGE_KEY = 'useClear_lastValue';
const CLEAR_WITH_MENU_VALUE = 'true-with-menu';

/**
 * Retorna true se a query string 'clear=true' estiver presente.
 * Caso a query string não seja informada, utiliza o último valor que foi definido.
 * O valor persiste durante a sessão da aba do navegador.
 */
export function useClear(): boolean {
  return useMemo(() => {
    // Em ambiente de Server-Side Rendering (SSR), window não existe.
    if (typeof window === 'undefined') {
      return false;
    }

    const params = new URLSearchParams(window.location.search);
    const urlValue = params.get('clear');

    // 1. Se a query string 'clear' EXISTE na URL
    if (urlValue !== null) {
      const shouldClear = urlValue === 'true' || urlValue === CLEAR_WITH_MENU_VALUE;
      // Salva o valor mais recente no sessionStorage para uso futuro
      sessionStorage.setItem(CLEAR_STORAGE_KEY, String(shouldClear));
      return shouldClear;
    }

    // 2. Se a query string NÃO EXISTE, busca o último valor salvo
    const storedValue = sessionStorage.getItem(CLEAR_STORAGE_KEY);

    // Retorna o valor salvo (convertido para boolean) ou 'false' se nada for encontrado
    return storedValue === 'true';
  }, []); // O array de dependências vazio [] faz com que isso rode apenas uma vez
}

export function useClearWithMenu(): boolean {
  return useMemo(() => {
    if (typeof window === 'undefined') return false;

    const params = new URLSearchParams(window.location.search);
    return params.get('clear') === CLEAR_WITH_MENU_VALUE;
  }, []);
}